import React from 'react';
import { Footer as FlowbiteFooter } from "flowbite-react";
import { NavLink } from 'react-router-dom';
import InstagramSvg from '../../assets/svg/InstagramSvg'
import TiktokSvg from '../../assets/svg/TiktokSvg'
// import WhatsappSvg from '../../assets/svg/WhatsappSvg'
import logo from '../../assets/img/logo.png'
import CallSvg from '../../assets/svg/CallSvg'
// import { useTranslation } from 'react-i18next';

const CustomFooter = () => {
  // const { t } = useTranslation();

  return (
    <FlowbiteFooter >
      <div className="w-full text-center mt-[32px] bg-main">
        <div className="w-full flex justify-between flex-wrap items-center container">
          <NavLink to={'/'}>
            <FlowbiteFooter.Brand
              src={logo}
              className='w-[140px] h-[60.6] my-8'
            />
          </NavLink>
          <div className='flex gap-4 my-8'>
            <NavLink to={"/"}><p className='text-white font-bold text-[20px]'>Əsas</p></NavLink>
            <NavLink to={"/films"}><p className='text-white font-bold text-[20px]'>Seanslar</p></NavLink>
            <NavLink to={"/about-us"}><p className='text-white font-bold text-[20px]'>Haqqımızda</p></NavLink>
            <NavLink to={"/contact"}><p className='text-white font-bold text-[20px]'>Əlaqə</p></NavLink>
          </div>
          <div className='flex gap-4 my-8'>
            <a target='_blank' rel="noreferrer" href='tel:0505811134' className='bg-purple p-2 rounded-[50%]'>
              <CallSvg />
            </a>
            <a target='_blank' rel="noreferrer" href='https://www.instagram.com/skycinema.az/' className='bg-purple p-2 rounded-[50%]'>
              <InstagramSvg />
            </a>
            <a target='_blank' rel="noreferrer" href='https://www.tiktok.com/@skycinema.az' className='bg-purple p-2 rounded-[50%]'>
              <TiktokSvg />
            </a>
            {/* <a target='_blank' href='https://www.tiktok.com/@resmirusdilimerkezi?_t=8qTWgy8Nxt1&_r=1' className='bg-purple p-2 rounded-[50%]'>
                    <WhatsappSvg/>
                </a> */}
          </div>
        </div>

        <FlowbiteFooter.Divider />

        <p className='py-8 text-white'>© Copyright 2022, All Rights Reserved by SkyCinema</p>

        {/* Добавленная строка с ссылкой на разработчика */}
        <div className="w-full pb-4">
          <a
            href="https://rustammgasanovv.vercel.app/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white text-sm hover:text-purple-300 transition-colors"
          >
            created by rustammgasanovv
          </a>
        </div>
      </div>
    </FlowbiteFooter>
  );
}

export default CustomFooter;